<template>
  <v-menu v-if="grupos_computed.length === 1" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="#042333"
        small
        dark
        :class="props.classes_css"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon left small>mdi-cart</v-icon>
        <span>Adicionar consolidando</span>
        <span class="qtde-top-button-small">{{ produtos_selecionados.length }}</span>
      </v-btn>
    </template>

    <v-list>
      <span class="pl-14px pr-5 font-12 text-gray-800">
        Selecione a filial para a qual deseja consolidar a compra
      </span>

      <v-list-item
        v-for="(item, key) in filiais_grupo_computed"
        :key="key"
        @click="consolidarCompra(item)"
      >
        <v-list-item-title>
          {{ item.descricao }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import api from "@/api/api";
import {logout} from "@/helpers";

const props = defineProps({
  classes_css: String,
  produtos_selecionados: Array,
});

const emit = defineEmits(['consolidacao:filial-selecionada']);

const grupos_computed = computed(() => [...new Set(props.produtos_selecionados.map(item => item.id_grupo))]);

const filiais = ref([]);
const filiais_grupo_computed = computed(() => filiais.value.filter(item => grupos_computed.value.includes(item.id_grupo)))

onMounted(buscarFiliais);

function buscarFiliais() {
  api.get('grupo/filiais', { params: { grupos: [] } })
    .then(resp => filiais.value = resp.data.filiais)
    .catch(logout)
}

function consolidarCompra(item) {
  emit('consolidacao:filial-selecionada', { filial: item.id });
}
</script>

<style scoped>

</style>
